<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3>Connection failed</h3>
  </div>

  <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px">
    <span class="domain__text">Your Schlage account has not been connected. Please try to connect account again.</span>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <sbnb-button label="Connect again" (clicked)="connectAccount()"></sbnb-button>
  </div>
</div>
